import React from "react";
import { motion } from "framer-motion";
import { StarIcon } from "lucide-react";
import { AVATARS } from "./constants";
const testimonials = [{
  img: AVATARS.maria,
  quote: "Ahora reviso cada planificación utilizando el checklist antes de aprobarla. Me ayuda a detectar detalles que antes pasaban desapercibidos.",
  name: "Dra. María P.",
  country: "Colombia 🇨🇴"
}, {
  img: AVATARS.roberto,
  quote: "El Tomo sobre planificación cambió mi forma de revisar los setups. Hoy analizo cada caso con mucho más criterio clínico.",
  name: "Dr. Roberto G.",
  country: "México 🇲🇽"
}, {
  img: AVATARS.andrea,
  quote: "Los protocolos de rescate me dieron alternativas para actuar cuando un movimiento deja de seguir el plan inicial.",
  name: "Dra. Andrea L.",
  country: "Argentina 🇦🇷"
}, {
  img: AVATARS.carolina,
  quote: "Los scripts para pacientes me ayudaron a explicar mejor el tratamiento y a reducir muchas dudas durante los controles.",
  name: "Dra. Carolina S.",
  country: "Venezuela 🇻🇪"
}, {
  img: AVATARS.jorge,
  quote: "Es una herramienta práctica. No tengo que leer cientos de páginas; encuentro el protocolo que necesito y continúo trabajando.",
  name: "Dr. Jorge M.",
  country: "Chile 🇨🇱"
}];
export function Testimonials() {
  return <section className="bg-navy-50 px-5 py-12" data-id="element-214" data-mp="zwg0mh1po4nx">
      <div className="mx-auto max-w-md" data-id="element-215" data-mp="zxr38djf76dg">
        <h2 className="text-center font-display text-2xl font-extrabold text-navy-800 sm:text-3xl" data-id="element-216" data-mp="14vj2xtqb3ws7">
          Lo que opinan otros profesionales
        </h2>

        <div className="mt-6 space-y-4" data-id="element-217" data-mp="q63fonpzi9h9">
          {testimonials.map((t, i) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="rounded-2xl border border-navy-100 bg-white p-5" data-id="element-218" data-mp="v4o6jwjcjgt1" data-mpi={i}>
              <div className="mb-2 flex gap-0.5" data-id="element-219" data-mp="1xhh7q0787jns">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-220" data-mp="1sgtf5a3cmurg" data-mpi={s} />)}
              </div>
              <p className="text-sm italic leading-relaxed text-navy-800/80" data-id="element-221" data-mp="1ji7y5jdiznss">“{t.quote}”</p>
              <div className="mt-4 flex items-center gap-3 border-t border-navy-50 pt-4" data-id="element-222" data-mp="1ej4ua29a7nme">
                <img src={t.img} alt={t.name} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-brand/20" data-id="element-223" data-mp="1ekzibpfunvup" />
                <div data-id="element-224" data-mp="14qz48y2lbg9u">
                  <p className="font-display text-sm font-bold text-navy-800" data-id="element-225" data-mp="10s04drvpu9p9">{t.name}</p>
                  <p className="text-xs text-navy-800/60" data-id="element-226" data-mp="vsnf70hdgqji">{t.country}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}